<template>
  <Teleport to="#interview-page-overlays-teleport-target">
    <div class="interview-page-overlay">
      <slot />
    </div>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="postcss">
.interview-page-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(246, 249, 253, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
